// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_search_input_container__W7mP6 {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.style_search_select__f-jhT,
.style_search_input__W2KKw {
  border: none !important;
}

.style_productContainer__n5bUu {
  display: flex;
  gap: 25px;
}

.style_productContainer__n5bUu .style_leftpart__HDMFx {
  width: 65%;
}

.style_productContainer__n5bUu .style_rightpart__yyZMI {
  width: 33%;
}

.style_whiteContainer__JQnOZ {
  border: 1px solid rgb(209, 207, 207);
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  padding: 6px;
}

.style_whiteContainer__JQnOZ input::placeholder,
.style_whiteContainer__JQnOZ textarea::placeholder {
  color: transparent;
  /* Hides the placeholder text by making it transparent */
}

.style_whiteContainer__JQnOZ h3 {
  font-size: 22px;
  color: black;
  font-weight: 600;
  margin-bottom: 16px;
}

.style_whiteContainer__JQnOZ input,
.style_whiteContainer__JQnOZ select,
.style_whiteContainer__JQnOZ textarea {
  background-color: #F8FAFF;
  color: rgb(53, 52, 52);
}

.style_imageContainer__gURyl {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  max-height: 600px;
  overflow: scroll;
  color: black;
  background: white;
  width: 47%;
  padding: 0px 10px;

}

.style_imageContainer__gURyl::-webkit-scrollbar {
  display: none;
}

.style_urlText__4ruyg {
  font-size: 14px;
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}

@media screen and (max-width: 500px) {
  .style_imageContainer__gURyl {
    width: 90%;
  }

  .style_productContainer__n5bUu {
    display: block;
  }

  .style_productContainer__n5bUu .style_leftpart__HDMFx {
    width: 100%;
  }

  .style_productContainer__n5bUu .style_rightpart__yyZMI {
    width: 100%;
  }

  .style_whiteContainer__JQnOZ {
    margin-top: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/catalog/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".search_input_container {\n  display: flex;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.search_select,\n.search_input {\n  border: none !important;\n}\n\n.productContainer {\n  display: flex;\n  gap: 25px;\n}\n\n.productContainer .leftpart {\n  width: 65%;\n}\n\n.productContainer .rightpart {\n  width: 33%;\n}\n\n.whiteContainer {\n  border: 1px solid rgb(209, 207, 207);\n  border-radius: 10px;\n  background-color: white;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 6px;\n}\n\n.whiteContainer input::placeholder,\n.whiteContainer textarea::placeholder {\n  color: transparent;\n  /* Hides the placeholder text by making it transparent */\n}\n\n.whiteContainer h3 {\n  font-size: 22px;\n  color: black;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.whiteContainer input,\n.whiteContainer select,\n.whiteContainer textarea {\n  background-color: #F8FAFF;\n  color: rgb(53, 52, 52);\n}\n\n.imageContainer {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 20px;\n  max-height: 600px;\n  overflow: scroll;\n  color: black;\n  background: white;\n  width: 47%;\n  padding: 0px 10px;\n\n}\n\n.imageContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.urlText {\n  font-size: 14px;\n  text-decoration: underline;\n  color: blue;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 500px) {\n  .imageContainer {\n    width: 90%;\n  }\n\n  .productContainer {\n    display: block;\n  }\n\n  .productContainer .leftpart {\n    width: 100%;\n  }\n\n  .productContainer .rightpart {\n    width: 100%;\n  }\n\n  .whiteContainer {\n    margin-top: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search_input_container": `style_search_input_container__W7mP6`,
	"search_select": `style_search_select__f-jhT`,
	"search_input": `style_search_input__W2KKw`,
	"productContainer": `style_productContainer__n5bUu`,
	"leftpart": `style_leftpart__HDMFx`,
	"rightpart": `style_rightpart__yyZMI`,
	"whiteContainer": `style_whiteContainer__JQnOZ`,
	"imageContainer": `style_imageContainer__gURyl`,
	"urlText": `style_urlText__4ruyg`
};
export default ___CSS_LOADER_EXPORT___;
